import { render, staticRenderFns } from "./center-tab-btns.vue?vue&type=template&id=76d21cfb&"
import script from "./center-tab-btns.vue?vue&type=script&lang=js&"
export * from "./center-tab-btns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports